import React from 'react';
import styled, { css } from 'styled-components';
import { Box } from '../../Box';
import { Icon } from '../../Icon';
import { Text } from '../../Text';
export const InternalField = ({ children, fieldType, renderAsTitle, htmlFor, className, label, assistiveText, error, errorMsg, required, completed, ...marginProps }) => {
    const labelTag = fieldType === 'field' ? 'label' : 'legend';
    return (React.createElement(Container, { forwardedAs: fieldType === 'field' ? 'div' : 'fieldset', className: className, ...marginProps },
        label && (React.createElement(React.Fragment, null, renderAsTitle ? (React.createElement(Box, { mb: "16px" },
            React.createElement(Text, { tag: labelTag, typo: "heading-small", htmlFor: htmlFor }, label),
            assistiveText && (React.createElement(Text, { tag: "p", color: "sesame", mt: { custom: 4 } }, assistiveText)))) : (React.createElement(Text, { tag: labelTag, typo: "label", color: error ? 'strawberry' : 'sesame', htmlFor: htmlFor, mb: { custom: 4 } },
            label,
            required && (React.createElement(Text, { tag: "span", typo: "body-small", color: "strawberry" }, "*")))))),
        React.createElement(Box, null, children),
        fieldType === 'field' && assistiveText && !renderAsTitle && (React.createElement(Text, { tag: labelTag, typo: "caption", color: error ? 'strawberry' : 'sesame', mt: { custom: 4 } }, assistiveText)),
        error &&
            errorMsg &&
            (typeof errorMsg === 'string' ? (React.createElement(Box, { flex: true, alignItems: "center", mt: "8px", gap: { custom: 4 } },
                React.createElement(Icon, { render: "warning", size: 16, color: "strawberry" }),
                React.createElement(Text, { tag: "span", typo: "caption", color: "strawberry" }, errorMsg))) : (React.createElement(Box, { mt: "8px" }, errorMsg))),
        completed !== undefined && (React.createElement(AnimationWrapper, { "$displayStatus": completed, "$isError": !!(error && errorMsg) },
            React.createElement(StatusWrapper, { mt: '8px' },
                React.createElement(Icon, { render: "included", size: 16, color: "apple" }),
                React.createElement(Text, { typo: "caption", color: "apple" }, "Complete"))))));
};
const AnimationWrapper = styled(Box) `
  width: 0;
  overflow: hidden;

  ${({ $displayStatus }) => $displayStatus &&
    css `
      transition: width 0.6s ease-in;
      width: 100%;
    `}

  /* This enables animation to appear when previous state is error */
  ${({ $isError }) => $isError &&
    css `
      height: 0;
    `}
`;
const StatusWrapper = styled(Box) `
  display: flex;
  align-items: center;
  gap: 4px;
`;
const Container = styled(Box) `
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;

  // In case, the element is a 'fieldset', we remove the border
  border: 0;
`;
//# sourceMappingURL=InternalField.js.map